import React from 'react'
import PropTypes from 'prop-types'
import PermissionRouteWithFallback from './PermissionRouteWithFallback'

export default function TimeMachinePermissionRouteWithFallback({
  component: Component,
  path,
  exact,
  fallback: Fallback,
  children,
  requirePersonalData,
}) {
  return (
    <PermissionRouteWithFallback
      component={Component}
      path={path}
      exact={exact}
      fallback={Fallback}
      requirePersonalData={requirePersonalData}
      permissionName="DiscoveryTimeMachineManageContentPermission"
      permissionContext="DiscoveryManageContentContext"
    >
      {children}
    </PermissionRouteWithFallback>
  )
}

TimeMachinePermissionRouteWithFallback.propTypes = {
  children: PropTypes.node,
  component: PropTypes.elementType,
  fallback: PropTypes.elementType.isRequired,
  path: PropTypes.string,
  exact: PropTypes.bool,
  requirePersonalData: PropTypes.bool,
}
